
import React from 'react';
import { LucideIcon } from 'lucide-react';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { Progress } from '@/components/ui/progress';

interface DepartmentCardProps {
  name: string;
  icon: LucideIcon;
  taskCount: number;
  completedTaskCount: number;
  color?: string;
  className?: string;
}

const DepartmentCard: React.FC<DepartmentCardProps> = ({
  name,
  icon: Icon,
  taskCount,
  completedTaskCount,
  color = "bg-primary",
  className
}) => {
  const progressPercentage = taskCount > 0 
    ? Math.round((completedTaskCount / taskCount) * 100) 
    : 0;
    
  return (
    <Card className={cn(
      "overflow-hidden transition-all duration-300 hover:shadow-md",
      className
    )}>
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <div className={cn(
            "w-10 h-10 rounded-md flex items-center justify-center",
            color
          )}>
            <Icon className="h-5 w-5 text-white" />
          </div>
          <span className="text-sm font-medium text-muted-foreground">
            {completedTaskCount}/{taskCount} tasks
          </span>
        </div>
        <CardTitle className="text-lg mt-2">{name}</CardTitle>
      </CardHeader>
      <CardContent className="pb-3">
        <div className="space-y-2">
          <div className="flex justify-between text-xs text-muted-foreground">
            <span>Progress</span>
            <span>{progressPercentage}%</span>
          </div>
          <Progress value={progressPercentage} className="h-1" />
        </div>
      </CardContent>
      <CardFooter className="pt-0">
        <Button variant="outline" size="sm" className="w-full text-xs">
          View Department
        </Button>
      </CardFooter>
    </Card>
  );
};

export default DepartmentCard;
